import { useMediaQuery as useMediaQueryHook } from 'usehooks-ts'

const MOBILE_BREAKPOINT = 375;
const TABLET_BREAKPOINT = 768;
const SIDEBAR_BREAKPOINT = 768;

export function useMediaQuery() {
    const isMobile = useMediaQueryHook(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const isTablet = useMediaQueryHook(`(min-width: ${MOBILE_BREAKPOINT}px) and (max-width: ${TABLET_BREAKPOINT - 1}px)`)
    const isDesktop = useMediaQueryHook(`(min-width: ${TABLET_BREAKPOINT}px)`)
    const isMobileSidebar = useMediaQueryHook(`(max-width: ${SIDEBAR_BREAKPOINT - 1}px)`)

    return {
        isMobile: !!isMobile,
        isTablet: !!isTablet,
        isDesktop: !!isDesktop,
        isMobileSidebar: !!isMobileSidebar,
    }
}
